import { createBrowserRouter, createRoutesFromElements, Navigate, Route } from 'react-router';
import { NegotiationsPage } from 'pages/negotiations';
import { QuestionnairePage } from 'pages/questionnaire';
import { EsiaCallbackPage } from 'pages/esia-callback';
import { OfferPage } from 'pages/offer';
import { CreateCandidate } from 'pages/create-candidate';
import { KeycloakLayout } from 'widgets/keycloak-layout';
import { MainLayout } from 'widgets/main-layout';
import { PageRoutes } from 'shared/routes';
import { KeycloakTypes } from 'shared/keycloak/types';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/* <Route path="/" element={<KeycloakLayout type={KeycloakTypes.office} />}>
        <Route path="/" element={<MainLayout />}>
          <Route path={PageRoutes.Negotiations} element={<NegotiationsPage />} />
        </Route>
        <Route path={PageRoutes.Offer + '/:id'} element={<OfferPage />} />
      </Route> */}
      <Route path="/" element={<KeycloakLayout type={KeycloakTypes.mass} />}>
        <Route path={PageRoutes.Pyaterochka} element={<QuestionnairePage retailer="pyaterochka" />} />
        <Route path={PageRoutes.Perekrestok} element={<QuestionnairePage retailer="perekrestok" />} />
        <Route path={PageRoutes.Chizhik} element={<QuestionnairePage retailer="chizhik" />} />
      </Route>
      <Route path={PageRoutes.CreateCandidate} element={<CreateCandidate />} />
      {/* TODO: не должна быть доступна пользователям, но при этом бэк должени иметь к ней доступ */}
      <Route path={PageRoutes.FileGeneratorOffer + '/:id'} element={<OfferPage />} />
      <Route path={PageRoutes.Liveness} element={<>Ok</>} />
      <Route path={PageRoutes.EsiaCallback} element={<EsiaCallbackPage />} />
    </>,
  ),
);
